import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/navbar.css";
import jishnaLogoTrim from '../assets/logos/JishnaLogoTrim.png';

function NavigationBar({serviceslist}) {
  // const [subpages, setSubpages] = useState([]);
  // useEffect(() => {
  //   // On first load, extract subpages from dynamicData
  //   if (dynamicData.length > 0) {
  //     setSubpages(dynamicData[0].subpages);
  //   }
  // }, []);
  const [show, setShow] = useState(false);

  return (
    <Navbar bg="light" expand="lg">
      <Container>
        {/* Logo on the left */}
        <Navbar.Brand as={Link} to="/">
            <img
                src={jishnaLogoTrim} // replace with your logo path
                alt="JishnaDeoTechSolutions Logo"
                width="275px"
                height="auto" 
                className="d-inline-block align-top header_logo"
            />
        </Navbar.Brand>

        {/* Toggle for mobile view */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Links on the right */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            {/* <Nav.Link as={Link} to="#link3">Services</Nav.Link> */}
            {/* Dropdown link */}
            <NavDropdown title="Services ▾" id="basic-nav-dropdown" show={show} onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
                {serviceslist.map((service, index) => (
                    <NavDropdown.Item key={index} as={Link} to={`/service/${service.path}`}>
                    {service.title}
                    </NavDropdown.Item>
                ))}
              
            </NavDropdown>
            <Nav.Link as={Link} to="team">Team</Nav.Link>
            <Nav.Link as={Link} to="projects">Projects</Nav.Link>
            <Nav.Link as={Link} to="careers">Carrers</Nav.Link>
            <Nav.Link as={Link} to="contactus">ContactUs</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
